import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Cross2Icon } from "@radix-ui/react-icons";
import { Button } from "../ui/button";

const DeleteSetDialog = ({ open, onClose, set, onSetDelete }: any) => {
  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="bg-[rgba(0,0,0,.6)] data-[state=open]:animate-overlayShow fixed inset-0" />

        <Dialog.Content className="data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] max-h-[90vh] w-full max-w-[60vw] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-blackLight p-[25px] shadow-[hsl(206, 22%, 93%) 0px 10px 38px -10px, hsl(206, 22%, 93%) 0px 10px 20px -15px] focus:outline-none text-body">
          <Dialog.Title className="text-mauve12 m-0 text-[17px] font-medium">
            Delete Set
          </Dialog.Title>

          <div className="my-8 flex flex-col">
            <div className="w-full h-full  flex items-start gap-x-2 border-t border-borderColor pt-2">
              Are you sure you want to delete the set{" "}
              <span className="font-bold">{set?.internalName}</span>?
            </div>
          </div>

          <div className="py-2 h-full w-full flex items-end gap-x-2 justify-end ">
            <Button onClick={() => onClose()}>Cancel</Button>
            <Button
              onClick={() => onSetDelete(set?._id)}
              className="bg-red-500 hover:bg-red-600"
            >
              Delete
            </Button>
          </div>

          <Dialog.Close asChild>
            <button
              className="text-white hover:text-primary focus:shadow-violet7 absolute top-[10px] right-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full focus:shadow-[0_0_0_2px] focus:outline-none"
              aria-label="Close"
            >
              <Cross2Icon />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default DeleteSetDialog;
